export const locales = {
  en: {
    code: "en",
    messages: {
      alpha: "{_field_} may only contain alphabetic characters",
      alpha_num: "{_field_} may only contain alpha-numeric characters",
      alpha_dash:
        "{_field_} may contain alpha-numeric characters as well as dashes and underscores",
      alpha_spaces:
        "{_field_} may only contain alphabetic characters as well as spaces",
      between: "{_field_} must be between {min} and {max}",
      confirmed: "{_field_} confirmation does not match",
      digits: "{_field_} must be numeric and exactly contain {length} digits",
      dimensions: "{_field_} must be {width} pixels by {height} pixels",
      email: "{_field_} deve ser um email válido",
      excluded: "{_field_} não é um valor válido",
      ext: "{_field_} is not a valid file",
      image: "{_field_} must be an image",
      integer: "{_field_} must be an integer",
      length: "{_field_} must be {length} long",
      max_value: "{_field_} must be {max} or less",
      max: "{_field_} may not be greater than {length} characters",
      mimes: "{_field_} must have a valid file type",
      min_value: "{_field_} must be {min} or more",
      min: "{_field_} deverá ter no mínimo {length} caracteres",
      numeric: "{_field_} deverá conter somente caracteres numéricos",
      oneOf: "{_field_} não é um valor válido",
      regex: "{_field_} formato inválido",
      required_if: "{_field_} obrigatório",
      required: "{_field_} é obrigatório",
      size: "{_field_} size must be less than {size}KB",
      double: "{_field_} deve ser um número válido",
    },
  },
};
